import type React from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/promote/pageContext';

export const ErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for Promote page (error: ${error})`);
};
